<template>
  <div class="pos-layout d-flex">
    <CategorySidebar @selectCategory="onCategorySelect" />
    <div class="flex-grow-1 p-3">
      <ProductGrid :products="filteredProducts" @addToCart="addToCart" />
    </div>
    <CartSummary
      :cart="cart"
      :customer="selectedCustomer"
      @updateQty="updateQty"
      @removeItem="removeItem"
      @applyDiscount="applyDiscount"
    />
  </div>
</template>

<script>


import CategorySidebar from "@/components/pos/CategorySidebar.vue";
import ProductGrid from "@/components/pos/ProductGrid.vue";
import CartSummary from "@/components/pos/CartSummary.vue";

export default {
  name: 'POSLayout',
  components: { CategorySidebar, ProductGrid, CartSummary },
  data() {
    return {
      selectedCategory: 'All',
      products: [],
      cart: [],
      selectedCustomer: null,
    }
  },
  computed: {
    filteredProducts() {
      return this.selectedCategory === 'All'
        ? this.products
        : this.products.filter(p => p.category === this.selectedCategory)
    }
  },
  methods: {
    onCategorySelect(category) {
      this.selectedCategory = category
    },
    addToCart(product) {
      const found = this.cart.find(p => p.code === product.code)
      if (found) {
        found.qty++
      } else {
        this.cart.push({ ...product, qty: 1 })
      }
    },
    updateQty(item, qty) {
      const index = this.cart.findIndex(p => p.code === item.code)
      if (index !== -1) this.cart[index].qty = qty
    },
    removeItem(code) {
      this.cart = this.cart.filter(p => p.code !== code)
    },
    applyDiscount(code) {}
  }
}
</script>
